// extracted by mini-css-extract-plugin
module.exports = {"Notification":"Notification_Notification__3Mp_0","success":"Notification_success__2CnuL","warning":"Notification_warning__3yQYI"};